export function useShowMe() {
  const handleShowMe = () => {
    if(window.screen.width < 700){
      return false
    }
    return ["/"].includes(location.pathname)
  };

  return handleShowMe;
}



// WEBPACK FOOTER //
// ./src/views/AppViews/TopHeader/ButtonNews/hooks/index.js